import React from "react";
import { Create, SimpleForm } from "react-admin";
import BackButtonToolbar from "features/BackButtonToolbar";
import SaveForm from "./SaveForm";

const CreateHealthcareCourseDailyPrice = () => (
  <Create
    title="Създаване на дневна такса"
    actions={<BackButtonToolbar />}
  >
    <SimpleForm>
      <SaveForm />
    </SimpleForm>
  </Create>
);

export default CreateHealthcareCourseDailyPrice;
